import { rootApiWithoutToken } from '../';
import {
  AuthenticateDoubleAuthRequest,
  AuthenticateDoubleAuthResponse,
  AuthenticateRequest,
  AuthenticateSimpleAuthResponse,
  CheckLoginResponse,
  RequestResetPasswordRequest,
  RequestResetPasswordResponse,
  ResendDoubleAuthOtpRequest,
  ResendDoubleAuthOtpResponse,
  ResetPasswordByLinkRequest,
  ResetPasswordByOtpRequest,
  ValidateResetPasswordOtpRequest,
  ValidateResetPasswordOtpResponse,
} from './types';

export const AuthApi = rootApiWithoutToken.injectEndpoints({
  endpoints: builder => ({
    // AUTHENTICATION APIS
    checkLogin: builder.mutation<CheckLoginResponse, string>({
      query: (login: string) => ({
        url: `/wallet-web/check-methode?login=${login}`,
        headers: { authorization: undefined },
      }),
    }),

    authenticate: builder.mutation<any, AuthenticateRequest>({
      query: (body: AuthenticateRequest) => ({
        url: '/wallet-web/methode-Authenticated',
        method: 'POST',
        headers: { authorization: undefined },
        body,
      }),
    }),

    authenticateSimpleAuth: builder.mutation<AuthenticateSimpleAuthResponse, AuthenticateRequest>({
      query: (body: AuthenticateRequest) => ({
        url: '/wallet-web/simple-auth',
        method: 'POST',
        headers: { authorization: undefined },
        body,
      }),
    }),

    authenticateDoubleAuth: builder.mutation<AuthenticateDoubleAuthResponse, AuthenticateDoubleAuthRequest>({
      query: (body: AuthenticateDoubleAuthRequest) => ({
        url: '/wallet-web/validated-auth',
        method: 'POST',
        headers: { authorization: undefined },
        body,
      }),
    }),

    resendDoubleAuthOtp: builder.mutation<ResendDoubleAuthOtpResponse, ResendDoubleAuthOtpRequest>({
      query: (body: ResendDoubleAuthOtpRequest) => ({
        url: '/wallet-web/regenerated-Authenticated',
        method: 'POST',
        headers: { authorization: undefined },
        body,
      }),
    }),

    // RESET PASSWORD APIS
    requestResetPassword: builder.mutation<RequestResetPasswordResponse, RequestResetPasswordRequest>({
      query: (body: RequestResetPasswordRequest) => ({
        url: '/wallet-web/reset-password',
        method: 'POST',
        headers: { authorization: undefined },
        body,
      }),
    }),

    validateResetPasswordOtp: builder.mutation<ValidateResetPasswordOtpResponse, ValidateResetPasswordOtpRequest>({
      query: (body: ValidateResetPasswordOtpRequest) => ({
        url: '/wallet-web/reset-password-otp/step-two',
        method: 'POST',
        headers: { authorization: undefined },
        body,
      }),
    }),

    resetPasswordByOtp: builder.mutation<any, ResetPasswordByOtpRequest>({
      query: (body: ResetPasswordByOtpRequest) => ({
        url: '/wallet-web/reset-password-otp/finish',
        method: 'POST',
        headers: { authorization: undefined },
        body,
      }),
    }),

    resetPasswordByLink: builder.mutation<any, ResetPasswordByLinkRequest>({
      query: (body: ResetPasswordByLinkRequest) => ({
        url: '/wallet-web/reset-password/finish',
        method: 'POST',
        headers: { authorization: undefined },
        body,
      }),
    }),
  }),
  overrideExisting: false,
});

// Export hooks for usage in function components, which are
// auto-generated based on the defined endpoints
export const {
  useCheckLoginMutation,
  useAuthenticateMutation,
  useAuthenticateDoubleAuthMutation,
  useResendDoubleAuthOtpMutation,
  useRequestResetPasswordMutation,
  useValidateResetPasswordOtpMutation,
  useResetPasswordByOtpMutation,
  useResetPasswordByLinkMutation,
  useAuthenticateSimpleAuthMutation,
} = AuthApi;

/**
 * Example Usage:
 *
 * export function MyComponentNeedingThisSlice() {
 *  const { actions } = useAuthSlice();
 *
 *  const onButtonClick = (evt) => {
 *    dispatch(actions.someAction());
 *   };
 * }
 */
